/**
 *
 * Asynchronously loads the component for ShapeSwitcher
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ShapeSwitcher = lazyLoad(
  () => import('./index'),
  module => module.ShapeSwitcher,
);
